import { monitorForElements } from '@atlaskit/pragmatic-drag-and-drop/element/adapter';
import _ from 'lodash';
import React, { useCallback, useEffect, useRef } from 'react';
import styled from 'styled-components';
import moveCard from './moveCard';

const Styled = {
  Board: styled.div`
    display: flex;
    gap: 1rem;
    height: 100%;
  `,
};

export default function Board({ cards, onDrop, onMove, ...props }) {
  const ref = useRef();

  const handleDrop = useCallback(
    (args) => {
      if (_.isFunction(onDrop)) {
        onDrop(args);
      }

      if (_.isFunction(onMove)) {
        const card = moveCard({ cards, ...args });
        onMove(card);
      }
    },
    [cards, onDrop, onMove],
  );

  useEffect(() => {
    return monitorForElements({
      element: ref.current,
      onDrop: handleDrop,
    });
  }, [handleDrop]);

  return <Styled.Board ref={ref} {...props} />;
}
